import React, {useEffect, useContext} from 'react';
import Icon_Close from '../Assets/Icons/Icon_Close.png';
import Icon_Color_Unsaved from '../Assets/Icons/Icon_Color_Unsaved.png';
import { Context_UI } from '../Contexts/Context_UI';
import { useStatus } from '../Contexts/Context_Status_Global';

export default function Subwindow_Modal_UnsavedChanges({ zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { List_Unsaved, Confirmer_Respond, Unsaved_Remove_All } = useStatus();
    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_General_UnsavedChanges");
    }

    const Discard = () => {
        Unsaved_Remove_All();
        Confirmer_Respond(true, {}, true, "Window_General_UnsavedChanges");
    }

    useEffect(() => {
        const el = document.getElementById("Window_General_UnsavedChanges");
        if (el) {
            el.setAttribute("Visibility", "Open");
            el.setAttribute("State", isActive ? "Active" : "Inactive");
            el.style.zIndex = zIndex;
        }
    }, [zIndex, isActive]);



    return (
        <ui-subwindow Type='Modal' id='Window_General_UnsavedChanges' State='Inactive' Visibility='Close'>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    
                </h2>
                <button className='Subwindow_TitleBar_Control'>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Color_Unsaved} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>

                <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Unsaved changes
                </h2>
                
                <p className='General_Paragraph' style={{marginBottom: "10px"}}>
                    There are unsaved changes in the following editor(s):
                </p>
                <ul className='General_Paragraph'>
                    {List_Unsaved.map(Item => 
                        <li className='General_Paragraph'>
                            {Item}
                        </li>
                    )}
                </ul>
                <p className='General_Paragraph' style={{marginBottom: "10px", textAlign: "left"}}>
                    Click "Discard" to discard your changes.
                </p>
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Discard}>
                    Discard unsaved changes
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
